// Comprehensive fix for add to cart functionality
document.addEventListener('DOMContentLoaded', function() {
  // Get cart action setting from theme settings
  let cartAction = 'open_cart_drawer'; // Default behavior
  
  // Try to get the actual setting if available in the DOM
  const settingsElement = document.querySelector('[data-cart-settings]');
  if (settingsElement) {
    try {
      const settings = JSON.parse(settingsElement.getAttribute('data-cart-settings'));
      if (settings && settings.action_after_atc) {
        cartAction = settings.action_after_atc;
      }
    } catch (e) {
      console.error('Error parsing cart settings:', e);
    }
  }

  // Fix for the add to cart functionality
  const fixAddToCart = function() {
    // Fix section-id attribute on all buy buttons
    document.querySelectorAll('hdt-buy-buttons').forEach(button => {
      if (!button.hasAttribute('section-id')) {
        const sectionId = button.closest('section[id]')?.id || 'main';
        button.setAttribute('section-id', sectionId);
      }
      
      // Get the form and submit button
      const form = button.closest('form');
      const submitBtn = button.querySelector('button[type="submit"]');
      
      if (form && submitBtn) {
        // Remove existing listeners to prevent duplicates
        //const newSubmitBtn = submitBtn.cloneNode(true);
        const newSubmitBtn = submitBtn;
        submitBtn.parentNode.replaceChild(newSubmitBtn, submitBtn);
        
        // Add new submit handler
        newSubmitBtn.addEventListener('click', function(e) {
          e.preventDefault();
          
          // Show loading state
          newSubmitBtn.classList.add('loading');
          newSubmitBtn.disabled = true;
          
          // Get form data
          const formData = new FormData(form);
          
          // Add to cart via fetch API
          fetch('/cart/add.js', {
            method: 'POST',
            body: formData
          })
          .then(response => response.json())
          .then(data => {
            // Success - update cart
            newSubmitBtn.classList.remove('loading');
            newSubmitBtn.disabled = false;
            
            // Handle different cart actions based on theme settings
            handleCartAction(cartAction);
          })
          .catch(error => {
            console.error('Error adding to cart:', error);
            newSubmitBtn.classList.remove('loading');
            newSubmitBtn.disabled = false;
          });
        });
      }
    });
  };
  
  // Handle product cards with add to cart buttons
  const fixQuickAddButtons = function() {
    document.querySelectorAll('.card-product').forEach(card => {
      const addBtn = card.querySelector('.add-to-cart-btn');
      if (addBtn) {
        // Remove existing listeners
        const newAddBtn = addBtn.cloneNode(true);
        addBtn.parentNode.replaceChild(newAddBtn, addBtn);
        
        newAddBtn.addEventListener('click', function(e) {
          e.preventDefault();
          
          // Show loading state
          newAddBtn.classList.add('loading');
          newAddBtn.disabled = true;
          
          // Get product variant ID
          const variantId = newAddBtn.getAttribute('data-id') || 
                          card.getAttribute('data-id') || 
                          card.querySelector('[data-id]')?.getAttribute('data-id');
          
          if (!variantId) {
            console.error('No variant ID found');
            newAddBtn.classList.remove('loading');
            newAddBtn.disabled = false;
            return;
          }
          
          // Add to cart via fetch API
          fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              id: variantId,
              quantity: 1
            })
          })
          .then(response => response.json())
          .then(data => {
            // Success - update cart
            newAddBtn.classList.remove('loading');
            newAddBtn.disabled = false;
            
            // Handle different cart actions based on theme settings
            handleCartAction(cartAction);
          })
          .catch(error => {
            console.error('Error adding to cart:', error);
            newAddBtn.classList.remove('loading');
            newAddBtn.disabled = false;
          });
        });
      }
    });
  };

  // Handle cart action based on theme settings
  const handleCartAction = function(action) {
    // Dispatch cart update event to update cart count
    document.dispatchEvent(new CustomEvent('cart:refresh'));
    console.log('Cart action:', action); // Debug cart action
    
    switch(action) {
      case 'open_cart_drawer':
        // Directly trigger cart drawer by clicking the cart icon
        const cartIcons = document.querySelectorAll('a[href="/cart"], [data-cart-drawer-toggle], .js-drawer-open-cart, .cart-drawer-trigger, .header-cart a, .cart-icon, .cart-link');
        if (cartIcons.length > 0) {
          console.log('Found cart icons:', cartIcons.length);
          // Click the first cart icon to open the drawer
          cartIcons[0].click();
        }
        
        // Force open any cart drawer we can find
        setTimeout(() => {
          // Try to find the cart drawer with various selectors
          const cartDrawerSelectors = [
            'hdt-cart-drawer',
            '#cart-drawer',
            '.cart-drawer',
            '.drawer--cart',
            '[data-cart-drawer]',
            '.mini-cart',
            '.drawer__inner',
            '.cart-sidebar',
            '.cart-popup',
            '.cart-notification',
            '.cart-notification-wrapper',
            '.cart-notification-drawer',
            '.cart-drawer-container'
          ];
          
          let drawerFound = false;
          
          for (const selector of cartDrawerSelectors) {
            const drawerElements = document.querySelectorAll(selector);
            console.log(`Found ${drawerElements.length} elements with selector: ${selector}`);
            
            drawerElements.forEach(drawer => {
              // Force open the drawer with multiple methods
              drawer.setAttribute('open', '');
              drawer.setAttribute('aria-hidden', 'false');
              drawer.setAttribute('data-drawer-opened', '');
              
              // Force visibility with CSS
              drawer.style.display = 'block';
              drawer.style.visibility = 'visible';
              drawer.style.opacity = '1';
              drawer.style.transform = 'none';
              drawer.style.pointerEvents = 'auto';
              
              // Add all possible active classes
              drawer.classList.add(
                'active', 'is-active', 'drawer--is-open', 
                'cart-drawer--open', 'is-visible', 'is-transitioning',
                'is-open', 'drawer-open', 'visible', 'show'
              );
              
              // Try to find and open any dialog elements
              const dialogs = drawer.querySelectorAll('dialog, [role="dialog"]');
              dialogs.forEach(dialog => {
                if (typeof dialog.showModal === 'function') {
                  try {
                    dialog.showModal();
                  } catch (e) {
                    console.log('Error showing modal:', e);
                  }
                }
                dialog.setAttribute('open', '');
                dialog.style.display = 'block';
              });
              
              drawerFound = true;
            });
          }
          
          // If no drawer found, try to find it in iframes or create one
          if (!drawerFound) {
            // Try to find cart drawer in any iframes
            document.querySelectorAll('iframe').forEach(iframe => {
              try {
                const iframeDoc = iframe.contentDocument || iframe.contentWindow.document;
                cartDrawerSelectors.forEach(selector => {
                  const drawerElements = iframeDoc.querySelectorAll(selector);
                  drawerElements.forEach(drawer => {
                    drawer.style.display = 'block';
                    drawer.style.visibility = 'visible';
                  });
                });
              } catch (e) {
                console.log('Error accessing iframe:', e);
              }
            });
          }
          
          // Also try to update the cart drawer content
          updateCartDrawer();
        }, 100); // Short delay to ensure DOM is ready
        break;
      
      case 'go_cart_page':
        // Redirect to cart page
        window.location.href = '/cart';
        break;
      
      case 'go_checkout_page':
        // Redirect to checkout
        window.location.href = '/checkout';
        break;
      
      default:
        // No action or unknown action
        break;
    }
  };
  
  // Update cart drawer content
  const updateCartDrawer = function() {
    return new Promise((resolve) => {
      const cartDrawer = document.querySelector('hdt-cart-drawer');
      if (!cartDrawer) {
        resolve();
        return;
      }
      
      // Get the section ID from the cart drawer
      const sectionId = cartDrawer.getAttribute('section-id') || 'cart-drawer';
      
      // Fetch updated cart drawer content
      fetch(`/?section_id=${sectionId}`)
        .then(response => response.text())
        .then(html => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          const cartDrawerContent = doc.querySelector('hdt-cart-drawer');
          
          if (cartDrawerContent) {
            // Update the inner content, preserving the outer element
            cartDrawer.innerHTML = cartDrawerContent.innerHTML;
          }
          resolve();
        })
        .catch(error => {
          console.error('Error updating cart drawer:', error);
          resolve();
        });
    });
  };
  
  // Update cart count and other elements
  const updateCartElements = function() {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        console.log('Cart data:', cart); // Debug cart data
        
        // Direct update of cart count in the header
        // First try with specific selectors for this theme
        const headerCartCount = document.querySelector('.header-cart .count');
        if (headerCartCount) {
          headerCartCount.textContent = cart.item_count;
          headerCartCount.style.display = cart.item_count > 0 ? 'block' : 'none';
          console.log('Updated header cart count:', headerCartCount);
        }
        
        // Update all possible cart count elements
        const allPossibleSelectors = [
          '.cart-count-bubble',
          '.cart-count', 
          '[data-cart-count]', 
          '.header__icon--cart .count-bubble',
          '.header-cart-count',
          '.cart-item-count',
          '.count-container',
          '.cart-count-number',
          '.cart-drawer-count',
          '.site-header__cart-count',
          '.js-cart-count',
          '#CartCount',
          '#CartBubble',
          '.cart-link__bubble',
          '.header-bar__cart-count',
          '.cart-count-number',
          '.cart-drawer-toggle .count',
          '.header-cart .count',
          '.cart-icon .count',
          '.cart-icon-count',
          '.cart-icon-bubble'
        ];
        
        // Try all selectors and update any matching elements
        allPossibleSelectors.forEach(selector => {
          const elements = document.querySelectorAll(selector);
          if (elements.length > 0) {
            console.log(`Found ${elements.length} elements with selector: ${selector}`);
          }
          
          elements.forEach(element => {
            // Update text content - try different approaches
            element.textContent = cart.item_count.toString();
            element.innerHTML = cart.item_count.toString();
            
            // Set data attributes that might be used
            element.setAttribute('data-cart-count', cart.item_count);
            element.setAttribute('data-item-count', cart.item_count);
            
            // Make sure it's visible
            element.classList.remove('hide', 'hidden', 'invisible', 'visually-hidden', 'display-none');
            element.style.display = cart.item_count > 0 ? 'block' : 'none';
            element.style.visibility = 'visible';
            element.style.opacity = '1';
            element.style.pointerEvents = 'auto';
            
            // If it's a span inside another element, make sure parent is visible too
            const parent = element.parentElement;
            if (parent) {
              parent.style.display = 'block';
              parent.style.visibility = 'visible';
              parent.style.opacity = '1';
            }
          });
        });
        
        // Force update any cart count elements by adding a custom attribute
        document.querySelectorAll('a[href="/cart"], [data-cart-drawer-toggle], .header-cart a, .cart-icon, .cart-link').forEach(cartLink => {
          // Find any child that might be a count indicator
          const countElements = cartLink.querySelectorAll('span, div, p');
          let updatedExisting = false;
          
          countElements.forEach(el => {
            if (el.textContent.trim().match(/^\d+$/) || 
                el.textContent.trim() === '' || 
                el.className.includes('count') || 
                el.className.includes('badge') ||
                el.hasAttribute('data-cart-count')) {
              el.textContent = cart.item_count.toString();
              el.style.display = cart.item_count > 0 ? 'block' : 'none';
              updatedExisting = true;
            }
          });
          
          // Add a custom count element if none exists
          if (!updatedExisting && cart.item_count > 0) {
            const countBubble = document.createElement('span');
            countBubble.className = 'cart-count-bubble';
            countBubble.textContent = cart.item_count.toString();
            countBubble.style.display = 'block';
            countBubble.style.position = 'absolute';
            countBubble.style.top = '0';
            countBubble.style.right = '0';
            countBubble.style.backgroundColor = 'red';
            countBubble.style.color = 'white';
            countBubble.style.borderRadius = '50%';
            countBubble.style.padding = '2px 6px';
            countBubble.style.fontSize = '12px';
            
            // Make sure the parent has position relative
            if (window.getComputedStyle(cartLink).position === 'static') {
              cartLink.style.position = 'relative';
            }
            cartLink.appendChild(countBubble);
          }
        });
        
        // Update any cart count in the page title
        const originalTitle = document.title.replace(/^\(\d+\)\s*/, '');
        document.title = cart.item_count > 0 ? `(${cart.item_count}) ${originalTitle}` : originalTitle;
      })
      .catch(error => console.error('Error fetching cart:', error));
  };
  
  // Listen for cart:refresh events
  document.addEventListener('cart:refresh', function() {
    updateCartElements();
  });
  
  // Fix for sectionId errors
  const fixSectionIdErrors = function() {
    // Define a global sectionId getter that never returns null
    Object.defineProperty(window, 'sectionId', {
      get: function() {
        // Try to find a section ID from various sources
        const buyButton = document.querySelector('hdt-buy-buttons');
        if (buyButton && buyButton.getAttribute('section-id')) {
          return buyButton.getAttribute('section-id');
        }
        
        // Find any element with section-id attribute
        const sectionIdElement = document.querySelector('[section-id]');
        if (sectionIdElement) {
          return sectionIdElement.getAttribute('section-id');
        }
        
        // Find any section element with an ID
        const section = document.querySelector('section[id]');
        if (section) {
          return section.id;
        }
        
        // Last resort fallback
        return 'main';
      },
      configurable: true
    });
    
    // Patch HTMLElement prototype to ensure section-id is always available
    const originalGetAttribute = HTMLElement.prototype.getAttribute;
    HTMLElement.prototype.getAttribute = function(name) {
      if (name === 'section-id' && !originalGetAttribute.call(this, 'section-id')) {
        // Try to find a section ID from parent elements
        let parent = this.closest('[section-id]');
        if (parent) {
          return parent.getAttribute('section-id');
        }
        
        // Find any section with an ID
        parent = this.closest('section[id]');
        if (parent) {
          return parent.id;
        }
        
        // Last resort fallback
        return 'main';
      }
      return originalGetAttribute.call(this, name);
    };
  };
  
  // Run all fixes
  fixSectionIdErrors();
  fixAddToCart();
  fixQuickAddButtons();
  
  // Also run fixes after any content changes
  document.addEventListener('shopify:section:load', function() {
    fixAddToCart();
    fixQuickAddButtons();
  });
  
  // Global error handler for the specific error
  window.addEventListener('error', function(event) {
    if (event.error && event.error.message && 
        (event.error.message.includes("Cannot read properties of null (reading 'sectionId')") ||
         event.error.message.includes("section-id"))) {
      console.log('Caught sectionId error, preventing page break');
      event.preventDefault();
    }
  });
});